import React, { useEffect, useState } from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../../services/firebase'
import LoadingSpinner from '../../../components/common/LoadingSpinner'

function PricingPage() {
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(true)
  const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const toHtml = (s) => {
    let h = escapeHtml(s || '')
    h = h.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    h = h.replace(/\*(.+?)\*/g, '<em>$1</em>')
    return h
  }

  useEffect(() => {
    const run = async () => {
      try {
        const snap = await getDocs(collection(db, 'plans'))
        const data = snap.docs.map(d => ({ id: d.id, ...d.data() }))
        const active = data.filter(p => p.active !== false)
        setPlans(active)
      } catch {
        setPlans([])
      } finally { setLoading(false) }
    }
    run()
  }, [])

  if (loading) return (<div className="flex items-center justify-center h-64"><LoadingSpinner size="large" /></div>)

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900">Elige un plan adecuado para ti</h1>
          <p className="mt-4 text-gray-600">Planes anuales con diferentes cantidades de Dkards</p>
        </div>

        {plans.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {plans.map((plan) => (
              <div key={plan.id} className="rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900">{plan.name}</h3>
                  <p className="mt-1 text-sm text-gray-600">Máx. Dkards: {plan.cards}</p>
                  <div className="mt-3 flex items-baseline gap-3">
                    {plan.discountPrice ? (
                      <>
                        <p className="text-xl line-through text-gray-500">Bs. {plan.price}</p>
                        <p className="text-2xl font-bold text-primary-600">Bs. {plan.discountPrice}</p>
                      </>
                    ) : (
                      <p className="text-2xl font-bold text-primary-600">Bs. {plan.price}</p>
                    )}
                    <span className="text-sm text-gray-500">/ Anual</span>
                  </div>
                </div>
                <div className="px-6 pb-6">
                  <ul className="space-y-2">
                    {(plan.features || []).map((f) => (
                      <li key={f} className="flex items-center text-sm text-gray-700">
                        <CheckIcon className="w-5 h-5 text-green-600 mr-2" />
                        <span dangerouslySetInnerHTML={{ __html: toHtml(f) }} />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-8 text-center text-gray-600">
            <p className="text-lg">Aún no hay planes publicados.</p>
            <p className="text-sm">El administrador puede publicar planes desde el panel de administración.</p>
          </div>
        )}

        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold text-gray-900">Ponerse en contacto</h2>
          <p className="mt-2 text-gray-600">Urbanización El Castillo A-7 · admin@dkard.net · +591 76903541</p>
          <div className="mt-4">
            <a href="mailto:admin@dkard.net" className="btn-secondary">Enviar mensaje</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingPage
